import { createContext, ReactNode } from 'react';

export interface MenuItemTreeControllerValue {
  onAddChild?: (parentID: number, order: number) => void;
  onDelete?: () => void;
  onChangeOrder?: (
    index: number,
    direction: 'up' | 'down',
    parentID?: number,
  ) => void;
}

export const MenuItemTreeControllerContext =
  createContext<MenuItemTreeControllerValue>({});

interface MenuItemTreeControllerProps extends MenuItemTreeControllerValue {
  children?: ReactNode;
}

export const MenuItemTreeController = (props: MenuItemTreeControllerProps) => (
  <MenuItemTreeControllerContext.Provider
    value={{
      onAddChild: props.onAddChild,
      onDelete: props.onDelete,
      onChangeOrder: props.onChangeOrder,
    }}
  >
    {props.children}
  </MenuItemTreeControllerContext.Provider>
);
